import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=3474030b&scoped=true&"
import script from "./studentDetail.vue?vue&type=script&lang=js&"
export * from "./studentDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=3474030b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474030b",
  null
  
)

export default component.exports